import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CColumn',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
});